import _ from 'underscore';

import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { PureKnockoutView } from '@bingads-webui/knockout-view';

import template from '../shared/inline-edit/template.pug';
import { UpgradedUrlView } from './upgraded-url-view';
import ViewModel from '../shared/inline-edit/viewmodel';

class SingleViewWrapper extends DeterministicWrapperView {
  initialize(options) {
    this.view = options.view;
    this.listenTo(this.view, 'all', this.trigger);
    this.rendered = true;
  }
}

export class UpgradedUrlInlineEditView extends PureKnockoutView {
  initialize({ i18n, upgradedUrls, permissions }) {
    super.initialize({ i18n, upgradedUrls });
    this.i18n = i18n;
    const disableKeywordDestinationUrl = permissions ?
      permissions.IsKeywordDestinationURLDisabled : false;

    this.upgradedUrlView = new UpgradedUrlView({
      url: upgradedUrls.url,
      finalMobileUrl: upgradedUrls.mobileFinalUrl,
      isFinal: upgradedUrls.isFinal,
      showTitles: true,
      i18n,
      disableKeywordDestinationUrl,
    });

    this.upgradedUrlView.on('upgradedUrl:updated', ({ isValid }) => {
      this.viewModel.isValid(isValid);
    });

    this.setChild('childView', new SingleViewWrapper({
      view: this.upgradedUrlView.render(),
    }));

    // do not show errors before user interaction.
    this.viewModel.isValid(this.upgradedUrlView.isValid());
  }

  get events() {
    return {
      'click .btn-primary': 'save',
      'click .btn-default': 'cancel',
    };
  }

  get template() {
    return ({ model }) => template({ model, i18n: this.i18n, customClass: 'upgraded-url-inline-editor' });
  }

  get ViewModel() {
    return ViewModel;
  }

  save() {
    this.trigger('save', { upgradedUrls: this.upgradedUrlView.getValues() });
  }

  cancel() {
    this.trigger('close');
  }

  setErrors(errors) {
    if (errors && !_.isEmpty(errors) && _.isObject(errors)) {
      this.viewModel.error(errors[_.keys(errors)[0]]);
    } else {
      this.viewModel.error('');
    }
  }
}
